/* @flow */

import React from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import MainLogo from "icons/logo.svg";

import styles from "./styles.scss";

type Props = {
  className?: string,
  useMobile?: boolean,
};

const Logo = ({ className, ...props }: Props): React$Node => {
  const t = useTranslate();

  return (
    <div {...props} className={cn(styles.logo, className)}>
      <MainLogo
        aria-label={t("LOGO.TITLE")}
        className={styles.logoMain}
      />
    </div>
  );
};

export default Logo;
